import React, { FunctionComponent } from 'react';
import { withRouter, RouteComponentProps, Redirect } from 'react-router-dom';

import HomeComponent from './Home';

type HomeContainerParams = {
  viewId: string;
};

type HomeContainerParamsProps = RouteComponentProps<HomeContainerParams>;

const HomeContainer: FunctionComponent<HomeContainerParamsProps> = ({
  match
}: HomeContainerParamsProps) => {

  return (
    <HomeComponent />
  );
};

export const RedirectToHome = () => <Redirect to="/app" />;

export default withRouter(HomeContainer);
